import React, { useContext } from "react";
import "./Portfolio.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import Sidebar from "../../img/creataDoc.png";
import Ecommerce from "../../img/creatachain.png";
import HOC from "../../img/magnus.png";
import gym from "../../img/gym.png";
import ecomm from "../../img/ecommerce3.png";
import { themeContext } from "../../Context";

const Portfolio = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  return (
    <div className="portfolio" id="portfolio">
      {/* heading */}
      <span style={{ color: darkMode ? "white" : "" }}>Recent Projects</span>
      <span>Portfolio</span>

      {/* slider */}
      <Swiper
        spaceBetween={30}
        grabCursor={true}
        className="portfolio-slider"
        breakpoints={{
          320: { slidesPerView: 1 }, // Mobile screens
          480: { slidesPerView: 1 }, // Small tablets
          768: { slidesPerView: 2 }, // Medium screens
          1024: { slidesPerView: 3 }, // Large screens
        }}
      >
        <SwiperSlide>
          <img src={Sidebar} alt="Project 1" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={ecomm} alt="Project 5" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={Ecommerce} alt="Project 2" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={gym} alt="Project 3" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={HOC} alt="Project 4" />
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default Portfolio;
